import {ACTION_TYPE} from "../constants/CommonConstants";

export const FeatureConfigReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPE.GET_FEATURES_STATUS:
            return {
                ...state,
                featureStatus: action.featureStatus,
                loading: false
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/FeatureConfigReducer.js